export enum BunnyStatus {
    'Em fila',
    'Enviado',
    'Processando'
}
